// Mediathek — bewusst OHNE `PageLayout` (Schnitt F, 2026-08-12).
//
// Der Dateibrowser darunter ist eine eigene CSS-Insel: `BunnyCDNManager` bringt einen
// `<style>`-Block mit `.manager-header`/`.manager-title` samt eigenem Hintergrund und eigenem
// `padding: 24px` mit, und sein Kopf trägt eine Kennzahlenleiste (Dateien/Größe/Ordner) statt
// eines Aktionsknopfes. Ihn auf die Vorlage zu heben hieße, diese Insel aufzulösen — das ist ein
// eigener Schnitt, kein Einsetzen einer Vorlage. Sein `padding: 24px` liegt dabei auf dem `p-6`
// der Hülle, ist also derselbe Doppel-Polster-Fehler wie bei den sechs umgestellten Seiten und
// gehört mit in denselben Schnitt.
import React from 'react';
import { BunnyCDNManager } from '../components/admin/BunnyCDNManager';
import ErrorBoundary from '../components/admin/ErrorBoundary';

const BunnyCDNManagement: React.FC = () => {
  return (
    <ErrorBoundary>
      <BunnyCDNManager />
    </ErrorBoundary>
  );
};

export default BunnyCDNManagement;

